module.exports = __webpack_public_path__ + "static/media/tienda.40de9616.svg";